module.exports = __webpack_public_path__ + "static/media/cow.9c46298e.svg";